const styles = () => ({
  sidebar: {
    width: 940,
    maxWidth: '80vw',
    minHeight: 0,
  },

  events: {
    minHeight: 0,
  },

  input: {
    margin: '10px 0',
  },

  tabs: {
    background: '#FAFBFC',
    flexShrink: 0,
  },
});

export default styles;
